module.exports = __webpack_public_path__ + "static/media/IconEmail.84cf02e6.svg";